// External UI components
import { BounceLoader } from "react-spinners";

// Internal page components
import EmailHeader from "../EmailHeader/EmailHeader";
import EmailBody from "../EmailBody/EmailBody";

// Styles
import membership_styles from "../../UserPortalPage/Body/Memberships/memberships_styles";

// Utilities
import { set_dimensions } from "../../../services/globals";
import { useAppSelector } from "../../../services/StoreHelper";

export const Email = () => {
  const { club, app_error } = useAppSelector((state) => state.app);
  const isDesktop = set_dimensions().desktop;
  const isLoading = !club?.clubId;

  // The club is what failed to load, so club.usesSpanish is unknowable here —
  // English only, unlike Memberships which can rely on a loaded club.
  if (app_error) {
    return (
      <div className={isDesktop ? "Email" : "Email-Mobile"}>
        <p role="alert" style={membership_styles.message}>
          We couldn't load your club. Please refresh the page or contact your
          club.
        </p>
      </div>
    );
  }

  return (
    <div className={isDesktop ? "Email" : "Email-Mobile"}>
      {isLoading ? (
        <div style={{ ...membership_styles.loader, height: "80vh" }}>
          <BounceLoader />
        </div>
      ) : (
        <>
          <EmailHeader />
          <EmailBody />
        </>
      )}
    </div>
  );
};